import { ArrowDropDown } from "@mui/icons-material";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { ReactElement, useRef, useState } from "react";

import { ITypesLanguages } from "../../common/interfaces";
import { useTranslate } from "../../hooks/useTranslate";

export const SelectLanguage: React.FC = () => {
  const { currentLanguage, languages, handleChooseLanguage } = useTranslate();

  const [openBox, setOpenBox] = useState(false);

  const handleSelectLanguage = (language: ITypesLanguages) => {
    handleChooseLanguage(language);
    setOpenBox(false);
  };

  const buttonRef = useRef();
  const Icon = () => currentLanguage.flag as ReactElement;

  return (
    <Box ref={buttonRef} zIndex={10} position="relative">
      <Button
        sx={{ textTransform: "uppercase" }}
        startIcon={<SvgIcon sx={{ ml: 1 }} component={Icon} />}
        endIcon={<ArrowDropDown />}
        disableElevation={false}
        size="small"
        onClick={() => {
          setOpenBox(!openBox);
        }}
      >
        {currentLanguage.label}
      </Button>

      <Menu
        anchorEl={buttonRef.current}
        open={openBox}
        sx={{ position: "absolute" }}
      >
        {languages
          .filter((item) => item.language !== currentLanguage.language)
          .map((item) => (
            <MenuItem
              key={item.language}
              sx={{ fontSize: 14 }}
              onClick={() => {
                handleSelectLanguage(item.language);
              }}
              color="primary"
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                {item.flag}
                <Typography sx={{ fontSize: 14 }}>{item.label}</Typography>
              </Stack>
            </MenuItem>
          ))}
      </Menu>
    </Box>
  );
};
